const actions = {
  SET_STATE: 'virtaluser/SET_STATE',
  LOGIN: 'virtaluser/LOGIN',
  LOAD_CURRENT_ACCOUNT: 'virtaluser/LOAD_CURRENT_ACCOUNT',
  LOGOUT: 'virtaluser/LOGOUT',
  LOGIN_HELPER: 'virtualuser/LOGIN_HELPER',
}

export default actions
